function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.014 30.34l.009-9.29 9.197.03a1.239 1.239 0 001.248-1.247 1.266 1.266 0 00-1.258-1.258l-9.186-.03.009-9.363a1.253 1.253 0 00-1.258-1.258 1.268 1.268 0 00-1.264 1.264l-.008 9.348-9.36-.032a1.241 1.241 0 00-1.248 1.248 1.266 1.266 0 001.259 1.258l9.348.032-.007 9.303a1.253 1.253 0 001.258 1.258 1.268 1.268 0 001.261-1.264z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAdd;